// utils/appVersion.js
//
// One source of truth for the portal's version.
//
// It used to be two, and they disagreed: the login screen hardcoded
// "Version 1.0" while error reports were tagged `APP_VERSION = '11.8'`. Nothing
// kept them in step, so a beta bug report could name a version the user never
// saw on screen — and the version is often the first thing you check when a
// report says "it broke after the update".
//
// Change it HERE and both follow.
export const APP_VERSION = '16.35';

/** What the login screen shows. */
export const APP_VERSION_LABEL = `Version ${APP_VERSION}`;
